import { AMPLITUDE_PREFIX } from '@amplitude/analytics-core';
export var updateCookies = function (config, lastEventTime) {
    var _a;
    var cookieName = getCookieName(config.apiKey);
    config.cookieStorage.set(cookieName, {
        userId: config.userId,
        deviceId: config.deviceId,
        sessionId: config.sessionId,
        lastEventTime: lastEventTime !== null && lastEventTime !== void 0 ? lastEventTime : (_a = config.cookieStorage.get(cookieName)) === null || _a === void 0 ? void 0 : _a.lastEventTime,
        optOut: Boolean(config.optOut),
    });
};
export var checkSessionExpiry = function (config) {
    var _a;
    var cookieName = getCookieName(config.apiKey);
    var lastEventTime = (_a = config.cookieStorage.get(cookieName)) === null || _a === void 0 ? void 0 : _a.lastEventTime;
    var now = Date.now();
    if (lastEventTime && now - lastEventTime >= config.sessionTimeout) {
        config.sessionId = now;
        updateCookies(config);
    }
};
export var getCookieName = function (apiKey, limit) {
    if (limit === void 0) { limit = 10; }
    return "".concat(AMPLITUDE_PREFIX, "_").concat(apiKey.substring(0, limit));
};
export var getOldCookieName = function (apiKey) {
    return "".concat(AMPLITUDE_PREFIX.toLowerCase(), "_").concat(apiKey.substring(0, 6));
};
//# sourceMappingURL=session-manager.js.map